<template>
    <NuxtLoadingIndicator />
    <div class="flex min-h-screen flex-col bg-slate-50">
        <AppBar />
        <div class="px-[6%]">

            <slot />
        </div>
        <UNotifications />
    </div>
</template>

<script setup>

</script>

<style scoped>
/* Add any global styles for your layout here */
</style>
<style>
body {
    font-family: 'Bitter', 'Open Sans', sans-serif;
}
</style>